import React from "react";

const Divider = () => {
  return (
    <div className="border-t border-gray-400 opacity-70 w-[calc(100%-40px)] mx-[20px] my-1.5" />
  );
};

export default Divider;
